import React, { FC } from 'react';
import ReactPaginate from 'react-paginate';
import { ReactComponent as IconChevronLeft } from '../../icons/chevron-left.svg';
import { ReactComponent as IconChevronRight } from '../../icons/chevron-right.svg';
import * as StyledPager from './pager.styles';

interface Props {
	pageCount: number;
	activePage: number;
	theme?: 'default' | 'primary';
	onClick: any;
}

const Pager: FC<Props> = ({ pageCount, activePage, theme, onClick }) => {
	const onPageChange = value => {
		const selected = value.selected + 1;

		if (selected !== activePage) {
			onClick(selected);
		}
	};

	return (
		<StyledPager.Wrapper pagerTheme={theme}>
			<ReactPaginate
				pageCount={pageCount}
				pageRangeDisplayed={3}
				marginPagesDisplayed={1}
				forcePage={activePage - 1}
				previousLabel={<IconChevronLeft />}
				nextLabel={<IconChevronRight />}
				onPageChange={onPageChange}
			/>
		</StyledPager.Wrapper>
	);
};

export default Pager;
